import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { DomainDTO } from 'features/inventory/api/types/domainDTO'
import {
  QueryProps,
  QueryVariables,
} from 'features/inventory/domain/components/DomainsTable/types/api'
import { DomainAlert } from 'features/inventory/domain/types/DomainAlert'
import { Domain } from 'features/inventory/types/domain'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { DEFAULT_REFETCH_INTERVAL } from 'providers/tanstack-query/constants'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { gql } from 'providers/tanstack-query/utils'
import { sortToDTO } from './useGetDomains'

export type Alert = Pick<Domain, 'alerts' | 'id'>

type Node = Pick<DomainDTO, 'alerts' | 'id'>
type QueryData = {
  domains: {
    nodes: Node[] | null
  }
}

export const useGetAlerts = ({ filters, first, last, sort }: QueryProps): Alert[] => {
  const { workspaceId } = useWorkspaceParam()

  const { data } = useQuery<QueryVariables, QueryData, Alert[]>({
    options: {
      refetchInterval: DEFAULT_REFETCH_INTERVAL,
      select: (data: QueryData): Alert[] =>
        data.domains.nodes?.map(
          (domain: Node): Alert => ({
            alerts: alertsFromDTO<DomainAlert>(domain.alerts),
            id: domain.id,
          }),
        ) ?? [],
    },
    query: gql`
      ${ALERT_FRAGMENT}

      query getAlertsForDomainsTable(
        $first: Int
        $last: Int
        $sort: DomainSortInput
        $terms: [String!]
        $workspaceId: ID!
      ) {
        domains(first: $first, last: $last, sort: $sort, terms: $terms, workspaceId: $workspaceId) {
          nodes {
            alerts {
              ...AlertFragment
            }
            id
          }
        }
      }
    `,
    variables: {
      first,
      last,
      sort: sortToDTO(sort),
      terms: filters,
      workspaceId,
    },
  })

  return data ?? []
}
